const CheckmarkSmall = () => (
  <>
    <path
      fill="currentColor"
      d="m10 14.312 6.246-6.266a.48.48 0 0 1 .353-.14q.214 0 .355.139.14.138.14.354a.48.48 0 0 1-.14.355l-6.389 6.369a.78.78 0 0 1-.565.243.78.78 0 0 1-.566-.243l-2.388-2.37a.48.48 0 0 1-.14-.352q0-.214.139-.355a.48.48 0 0 1 .354-.14.48.48 0 0 1 .355.14z"
    />
  </>
)
export default CheckmarkSmall
